export const RENDERING_DETAILS_KEYS = {
    APPLY_COUPON_BUTTON: "apply_coupon_button",
    TRANSPARENT_SEPARATOR: "transparent_separator",
    DE_TIP_CARD_INFORMATION: "delivery_tip_card_information",
    DELIVERY_SPEED: "delivery_speed",
    DELIVERY_INSTRUCTIONS: "delivery_instructions",
    BILL_HEADING: "bill_heading",
    COUPON_REMOVE_BUTTON: "coupon_remove_button",
    BILL_DETAILS_SECTION_END: "bill_details_section_end",
};
